import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useContentHumanizacion = () => {
  const [contentHumanizacion, setContentHumanizacion] = useState({});
  const [isLoadingHumanizacion, setLoadingHumanizacion] = useState(false);

  const getContentHumanizacion = async () => {
    setLoadingHumanizacion(true);

    try {
      const responseContent = await fetchContent("humanizacion");
      setContentHumanizacion(responseContent.data.list);

      setLoadingHumanizacion(false);
    } catch (error) {
      console.error(" ERROR EN useContentHumanizacion --> ", error);
    }
  };

  useEffect(() => {
    getContentHumanizacion();
  }, []);

  return {
    contentHumanizacion , isLoadingHumanizacion
  };
};

export default useContentHumanizacion;
